(function () {
  "use strict";
  const CONFIG = {
    gridSelector: "#bls__product-grid",
    productSelector: ".bls__grid__item",
    sortSelector: ".facet-filters__sort li",
    sortAsc: "available_variants_asc",
    sortDesc: "available_variants_desc",
    countAttribute: "data-available-variant-count",
    initialDelay: 500,
    ajaxDelay: 700,
    resortDelay: 300,
    countCheckInterval: 500
  };

  let gridObserver = null;
  let bodyObserver = null;
  let countWatcher = null;
  let observedGrid = null;
  let lastProductCount = 0;
  let sortInProgress = false;
  let initialized = false;
  let resortTimer = null;
  let ajaxTimer = null;

  /* =========================================================
     HELPERS
  ========================================================= */

  function getGrid() {
    return document.querySelector(CONFIG.gridSelector);
  }
  function getProducts() {
    const grid = getGrid();
    return grid
      ? Array.from(
          grid.querySelectorAll(CONFIG.productSelector)
        )
      : [];
  }
  function getAvailableVariantCount(product) {
    const value = product.getAttribute(
      CONFIG.countAttribute
    );
    const count = Number.parseInt(value, 10);
    return Number.isFinite(count) ? count : 0;
  }
  function getCurrentSort() {
    return new URLSearchParams(
      window.location.search
    ).get("sort_by");
  }
  function isCustomSort(sortType) {
    return (
      sortType === CONFIG.sortAsc ||
      sortType === CONFIG.sortDesc
    );
  }

  /* =========================================================
     DROPDOWN UI
  ========================================================= */

  function updateSelectedOption(sortType) {
    document
      .querySelectorAll(CONFIG.sortSelector)
      .forEach((option) => {
        const selected =
          option.getAttribute("value") === sortType;

        option.classList.toggle(
          "selected",
          selected
        );

        if (selected) {
          option.setAttribute(
            "selected",
            "selected"
          );
        } else {
          option.removeAttribute(
            "selected"
          );
        }
      });
    const selectedLabel =
      document.querySelector(
        ".toolbar-sorter .select-selected span"
      );
    if (!selectedLabel) return;
    selectedLabel.textContent =
      sortType === CONFIG.sortDesc
        ? "Available Variants: High to Low"
        : "Available Variants: Low to High";
  }

  /* =========================================================
     URL
  ========================================================= */

  function updateURL(sortType) {
    const url = new URL(
      window.location.href
    );
    url.searchParams.set(
      "sort_by",
      sortType
    );
    window.history.replaceState(
      {},
      "",
      url.toString()
    );
  }

  /* =========================================================
     SORT PRODUCTS
  ========================================================= */

  function sortProducts(sortType) {
    if (
      sortInProgress ||
      !isCustomSort(sortType)
    ) {
      return;
    }
    const grid = getGrid();
    if (!grid) return;
    const products = Array.from(
      grid.querySelectorAll(
        CONFIG.productSelector
      )
    );
    if (products.length < 2) {
      lastProductCount =
        products.length;

      return;
    }
    sortInProgress = true;
    if (gridObserver) {
      gridObserver.disconnect();
    }
    const sortedProducts =
      products
        .map((product, index) => ({
          product,
          index,
          count:
            getAvailableVariantCount(
              product
            )
        }))
        .sort((a, b) => {
          const difference =
            sortType === CONFIG.sortDesc
              ? b.count - a.count
              : a.count - b.count;
          /*
           * Keep original Shopify order
           * when counts are equal.
           */
          return (
            difference ||
            a.index - b.index
          );
        });
    const fragment =
      document.createDocumentFragment();
    sortedProducts.forEach(
      ({ product }) => {
        fragment.appendChild(product);
      }
    );
    grid.appendChild(fragment);
    lastProductCount =
      sortedProducts.length;
    sortInProgress = false;
    attachGridObserver();
  }

  /* =========================================================
     GRID OBSERVER
  ========================================================= */
  function attachGridObserver() {
    const grid = getGrid();
    if (!grid) return;
    if (
      observedGrid === grid &&
      gridObserver
    ) {
      return;
    }
    if (gridObserver) {
      gridObserver.disconnect();
    }
    observedGrid = grid;
    lastProductCount =
      grid.querySelectorAll(
        CONFIG.productSelector
      ).length;
    gridObserver =
      new MutationObserver(
        (mutations) => {
          if (sortInProgress) {
            return;
          }
          let productAdded = false;
          mutations.forEach(
            (mutation) => {

              if (
                mutation.type !==
                "childList"
              ) {
                return;
              }
              mutation.addedNodes.forEach(
                (node) => {

                  if (
                    node.nodeType !== 1
                  ) {
                    return;
                  }
                  if (
                    node.matches?.(
                      CONFIG.productSelector
                    ) ||
                    node.querySelector?.(
                      CONFIG.productSelector
                    )
                  ) {
                    productAdded = true;
                  }
                }
              );
            }
          );
          if (!productAdded) {
            return;
          }
          const sortType =
            getCurrentSort();
          if (
            !isCustomSort(sortType)
          ) {
            return;
          }
          clearTimeout(
            resortTimer
          );
          resortTimer =
            setTimeout(() => {
              if (
                getCurrentSort() !==
                sortType
              ) {
                return;
              }
              sortProducts(
                sortType
              );

            }, CONFIG.resortDelay);
        }
      );

    gridObserver.observe(
      grid,
      {
        childList: true,
        subtree: true
      }
    );
  }

  function startCountWatcher() {
    clearInterval(
      countWatcher
    );
    countWatcher =
      setInterval(() => {
        const grid = getGrid();
        if (!grid) return;
        if (
          observedGrid !== grid
        ) {
          observedGrid = null;
          attachGridObserver();
        }
        const currentCount =
          grid.querySelectorAll(
            CONFIG.productSelector
          ).length;
        if (
          currentCount <=
          lastProductCount
        ) {
          return;
        }
        lastProductCount =
          currentCount;
        const sortType =
          getCurrentSort();
        if (
          !isCustomSort(sortType)
        ) {
          return;
        }
        clearTimeout(
          resortTimer
        );
        resortTimer =
          setTimeout(() => {
            if (
              getCurrentSort() !==
              sortType
            ) {
              return;
            }
            sortProducts(
              sortType
            );
          }, CONFIG.resortDelay);
      }, CONFIG.countCheckInterval);
  }

  /* =========================================================
     COLLECTION AJAX OBSERVER
  ========================================================= */
  function observeCollectionChanges() {
    if (bodyObserver) {
      bodyObserver.disconnect();
    }
    bodyObserver =
      new MutationObserver(
        (mutations) => {
          let collectionChanged = false;
          mutations.forEach(
            (mutation) => {
              if (
                mutation.type !==
                "childList"
              ) {
                return;
              }
              [
                ...mutation.addedNodes,
                ...mutation.removedNodes
              ].forEach(
                (node) => {

                  if (
                    node.nodeType !== 1
                  ) {
                    return;
                  }
                  if (
                    node.matches?.(
                      ".section-collection-product"
                    ) ||
                    node.matches?.(
                      CONFIG.gridSelector
                    ) ||
                    node.querySelector?.(
                      ".section-collection-product"
                    ) ||
                    node.querySelector?.(
                      CONFIG.gridSelector
                    )
                  ) {
                    collectionChanged = true;
                  }
                }
              );
            }
          );
          if (
            !collectionChanged
          ) {
            return;
          }
          clearTimeout(
            ajaxTimer
          );

          ajaxTimer =
            setTimeout(() => {
              const grid = getGrid();
              if (!grid) return;
              observedGrid = null;
              attachGridObserver();
              const sortType =
                getCurrentSort();
              if (
                !isCustomSort(sortType)
              ) {
                return;
              }
              updateSelectedOption(
                sortType
              );
              sortProducts(
                sortType
              );
            }, CONFIG.ajaxDelay);
        }
      );
    bodyObserver.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }
  /* =========================================================
     CUSTOM SORT CLICK
  ========================================================= */
  function handleSortClick(event) {
    const option =
      event.target.closest(
        CONFIG.sortSelector
      );
    if (!option) return;
    const sortType =
      option.getAttribute("value");
    if (
      !isCustomSort(sortType)
    ) {
      return;
    }
    updateURL(
      sortType
    );
    updateSelectedOption(
      sortType
    );
    /*
     * Let Shopify/theme AJAX sorting
     * run normally.
     */
    setTimeout(() => {
      if (
        getCurrentSort() !==
        sortType
      ) {
        return;
      }
      observedGrid = null;
      attachGridObserver();
      updateSelectedOption(
        sortType
      );
      sortProducts(
        sortType
      );
    }, CONFIG.ajaxDelay);
  }

  /* =========================================================
     INITIAL SORT
  ========================================================= */

  function applyInitialSort() {
    let sortType =
      getCurrentSort();
    /*
     * Default sorting:
     * Available Variants High → Low
     */
    if (
      !isCustomSort(sortType)
    ) {
      sortType =
        CONFIG.sortDesc;
      updateURL(
        sortType
      );
    }
    setTimeout(() => {
      updateSelectedOption(
        sortType
      );
      sortProducts(
        sortType
      );
      attachGridObserver();
    }, CONFIG.initialDelay);
  }

  /* =========================================================
     INIT
  ========================================================= */

  function init() {
    if (initialized) return;
    initialized = true;
    document.addEventListener(
      "click",
      handleSortClick,
      false
    );
    observeCollectionChanges();
    applyInitialSort();
    startCountWatcher();
  }
  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init
    );
  } else {
    init();
  }

})();